// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__5aVmH","head":"ProcedureTableInfo_head__3ISrU"};